import axios from 'axios'
axios.defaults.headers.post['Accept'] = '*/*'
axios.defaults.headers.post['content-type'] = 'multipart/form-data; charset=UTF-8'// x - www - form - urlencoded
axios.defaults.headers.post['Origin'] = null

export function request(config) {
    const instance = axios.create({
        // baseURL : '192.168.1.119:8888',
        // timeout: 5000
    })
    //配置请求拦截器
    instance.interceptors.request.use(config => {
        //每次请求都需要检查 token
        config.headers.Authorization = window.sessionStorage.getItem('token') ?'Bearer'+' '+window.sessionStorage.getItem('token'):'';
        return config
    }, err => {
        return Promise.reject(error)
    })

    //配置响应拦截器
    instance.interceptors.response.use(res => {
        //状态码为200表示成功
        if (res.status === 200)
            return res.data
    }, err => {
        console.log(err);
        return Promise.reject('网络错误')
    })
    //发送真正的数据请求
    return instance(config)
}